export default {
    day: '2025-01-20',
    content: {
        meta: [
            {
                type: 'bugfix',
                text: '428'
            },
        ],
        farm: [
            {
                unlock: 'farmFertilizer',
                type: 'bugfix',
                text: '442'
            },
        ],
    }
}
